import React from 'react';
import { Tooltip } from '@insly/qmt-reactjs-ui-lib';
import Pagination from 'app/Components/common/Pagination';
import { DefaultIcon } from 'styles/common';
import { TStandardSectionStep } from 'models';
import { List, ListInner, TitleWrapper, Title, TableStyled } from 'app/Pages/common/List/styles';
import { TTableData } from '../index';
import { TBroker } from 'app/Pages/common';
import { translate } from 'utils/translate';
interface IProps {
  step: TStandardSectionStep,
  title: string,
  dataStatus: string,
  noResultsText: string,
  brokerList: TTableData,
  updateSelectedUser: (user: TBroker) => void,
  selectedUser: TBroker | null,
  drawerType: string,
  handleListChangePage: (page: number) => void,
  handleSearchChange?: (value: string) => void,
  handleAddUserClick: () => void,
}

export const UserList = ({
  step,
  title,
  dataStatus,
  noResultsText,
  brokerList,
  updateSelectedUser,
  selectedUser,
  drawerType,
  handleListChangePage,
  handleSearchChange,
  handleAddUserClick,
}: IProps) => (
  <List step={step}>
    <ListInner>
      <TitleWrapper>
        <Title>{title}</Title>
        <Tooltip align="top" message={translate({ key: 'master.broker.add' })}>
          <DefaultIcon icon="add_broker" onClick={handleAddUserClick} />
        </Tooltip>
      </TitleWrapper>
      <TableStyled
        dataStatus={dataStatus}
        data={brokerList.results ? brokerList.results as never[] : undefined}
        noResultsText={noResultsText || 'No results'}
        onClickRow={drawerType === 'profile' ? (index, data: TBroker) => updateSelectedUser(data) : () => {}}
        selectedId={selectedUser ? selectedUser.id : undefined}
        handleSearchChange={handleSearchChange}
        columns={[
          {
            name: 'name',
            styles: {
              flex: 2
            }
          },
          {
            name: 'tag',
            styles: {
              flex: 1
            }
          },
          {
            name: 'tenant',
            styles: {
              flex: 1
            }
          }
        ]}
      />
      {brokerList?.last_page && brokerList.last_page > 1 ? Pagination({ page: brokerList.page as number, last_page: brokerList.last_page }, handleListChangePage) : null}
    </ListInner>
  </List>
);
